import { createCRUDEndpoints } from '@/api/factory/crud';
import { ProductJSON } from '@/store/modules/products/product';
import { PublishStatus } from '@/store/types';
import { createTranslateEndpoint } from '../factory/translate';
import httpClient from '../http-client';
import { RequestConfig } from '../types';

type ListParams =
  | {
      title?: string;
      search?: string;
      status?: PublishStatus;
      page?: string | number;
      sort?: string;
      direction?: 'asc' | 'desc';
    }
  | undefined;

export const { list, get, store, remove, restore } = createCRUDEndpoints<ProductJSON, ListParams>({
  slug: 'product',
});

export const translate = createTranslateEndpoint<ProductJSON>({ slug: 'product' });

export function listTree(config?: RequestConfig) {
  return httpClient.get<ProductJSON[]>('products/tree', config);
}
